import { render, staticRenderFns } from "./shebeiAuth.vue?vue&type=template&id=2c668ba0&scoped=true&"
import script from "./shebeiAuth.vue?vue&type=script&lang=js&"
export * from "./shebeiAuth.vue?vue&type=script&lang=js&"
import style0 from "./shebeiAuth.vue?vue&type=style&index=0&id=2c668ba0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c668ba0",
  null
  
)

export default component.exports